import {ActivatedRouteSnapshot, convertToParamMap, ParamMap, Params, Router} from '@angular/router';
import {AppParameter} from './app-parameter';

export class AppParameterMap {

  private readonly paramMap: ParamMap;

  private constructor(paramMap: ParamMap) {
    this.paramMap = paramMap;
  }

  has(appParameter: AppParameter): boolean {
    return this.paramMap.has(appParameter.name);
  }

  get(appParameter: AppParameter): string {
    const result = this.paramMap.get(appParameter.name);

    if (!result) {
      throw new Error('AppParameterMap does not contain requested parameter "' + appParameter.name + '"');
    }

    return result;
  }

  public static from(paramMap: ParamMap): AppParameterMap;
  public static from(router: Router): AppParameterMap;
  public static from(paramMapOrRouter: ParamMap | Router): AppParameterMap {
    let paramMap: ParamMap;

    if (AppParameterMap.isRouter(paramMapOrRouter)) {
      let params: Params = {};
      const stack: ActivatedRouteSnapshot[] = [paramMapOrRouter.routerState.snapshot.root];

      while (stack.length > 0) {
        const route = stack.pop();
        params = {...params, ...route.params};
        stack.push(...route.children);
      }

      paramMap = convertToParamMap(params);
    } else {
      paramMap = paramMapOrRouter;
    }

    return new AppParameterMap(paramMap);
  }

  public static empty() {
    return new AppParameterMap(convertToParamMap({}));
  }

  private static isRouter(maybeRouter: ParamMap | Router): maybeRouter is Router {
    return maybeRouter instanceof Router || !!((maybeRouter as unknown as Router)?.routerState?.snapshot?.root);
  }
}
